import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { itemService } from "../../api/services/itemService";
import { setUserLoggedIn, isUserLoggedIn } from "../../utils/authUtils";
import Loader from "../Loader/Loader";
import "./LoginCreation.css";

const LoginCreation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    phone: "",
  });

  const isLogin = true;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isNavigating, setIsNavigating] = useState(false);
  // If already logged in, redirect away from login page
  useEffect(() => {
    if (isUserLoggedIn()) {
      navigate("/my-account", { replace: true });
    }
  }, [navigate]);

  // Reset navigation loader when location changes
  useEffect(() => {
    setIsNavigating(false);
  }, [location.pathname]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLogin) {
      // Handle login logic
      setLoading(true);
      setErrorMessage("");
      try {
        const response = await itemService.accountLogin(
          formData.email,
          formData.password,
        );

        // Check if login was successful
        // API might return success status, token, userId, or other success indicators
        if (
          response &&
          (response.success === true ||
            response.Status === "Success" ||
            response.status === "success" ||
            response.token ||
            response.UserId ||
            response.userId ||
            (response.data && (response.data.token || response.data.UserId)))
        ) {
          // Save login status (UserId, Email, CustomerId from API response)
          setUserLoggedIn({
            email: response.Email ?? formData.email,
            userId:
              response.UserId ||
              response.userId ||
              response.data?.UserId ||
              response.data?.userId,
            customerId:
              response.CustomerId ??
              response.customerId ??
              response.data?.CustomerId ??
              response.data?.customerId,
            token: response.token || response.data?.token,
            IsUserEmailAddressVerified:
              response.IsUserEmailAddressVerified ??
              response.isUserEmailAddressVerified ??
              response.Data?.IsUserEmailAddressVerified ??
              response.data?.IsUserEmailAddressVerified ??
              null,
          });
          navigate("/");
        } else {
          // Login failed - show error message
          setErrorMessage("User and password incorrect");
        }
      } catch (error) {
        // Handle API error (network error, 401, 400, etc.)
        console.error("Login error:", error);
        // Check if error response has a message
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setErrorMessage(error.response.data.message);
        } else {
          setErrorMessage("User and password incorrect");
        }
      } finally {
        setLoading(false);
      }
    } else {
      // Handle registration logic
      if (formData.password !== formData.confirmPassword) {
        alert("Passwords do not match");
        return;
      }
      console.log("Registration data:", formData);
    }
  };

  const closeErrorPopup = () => {
    setErrorMessage("");
  };

  return (
    <div className="login-creation-container">
      {/* Loader Overlay */}
      {(loading || isNavigating) && <Loader />}

      <div className="login-creation-header">
        <h1>LOGIN OR CREATE AN ACCOUNT!</h1>
      </div>

      <div className="login-creation-content">
        {/* Left Side - Image Block */}
        <div className="login-image-block">
          <div className="image-placeholder">
            {/* You can replace this with an actual image URL */}
            <img
              src="https://5.imimg.com/data5/SELLER/Default/2021/8/GH/PW/MY/53210007/mobile-accessories.jpg"
              alt="Login"
              className="login-image"
            />
          </div>
        </div>

        {/* Right Side - Forms */}
        <div className="login-forms-section">
          {/* New Customers Card */}
          <div className="form-card new-customers-card">
            <h3>New Customers</h3>
            <p>
              By creating an account with our store, you will be able to move
              through the checkout process faster, store multiple shipping
              addresses, view and track your orders in your account and more.
            </p>
            <button
              type="button"
              className="create-account-btn"
              onClick={() => {
                setIsNavigating(true);
                navigate("/create-account");
              }}
            >
              Create an Account
            </button>
          </div>

          {/* Registered Customers Card */}
          <div className="form-card registered-customers-card">
            <h3>Registered Customers</h3>
            <p>if you have account with us, please log in.</p>

            <form onSubmit={handleSubmit} className="login-form">
              {errorMessage && (
                <div className="error-popup" onClick={closeErrorPopup}>
                  <div
                    className="error-popup-content"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      className="error-close"
                      onClick={closeErrorPopup}
                      aria-label="Close"
                    >
                      ×
                    </button>
                    <p className="error-message">{errorMessage}</p>
                  </div>
                </div>
              )}
              <div className="form-group">
                <label htmlFor="email">Username / Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Username / Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-options">
                <div className="checkbox-container">
                  <input type="checkbox" id="remember-me" />
                  <label htmlFor="remember-me" className="checkbox-text">
                    Remember me
                  </label>
                </div>
                <Link to="/forgotpassword" className="forgot-password">
                  Forgot Your Password?
                </Link>
              </div>

              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginCreation;
